import { cn } from "@/lib/utils";

export interface JobStatusBadgeProps {
  code: string;
  label?: string;
  color?: string | null;
  className?: string;
}

export function JobStatusBadge({ code, label, color, className }: JobStatusBadgeProps) {
  const bg = color ?? "#94A3B8";
  return (
    <span
      role="status"
      aria-label={`Job status: ${label ?? code}`}
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium text-white",
        className,
      )}
      style={{ backgroundColor: bg }}
    >
      {label ?? code}
    </span>
  );
}
